export default __webpack_public_path__ + "images/2826b1ab0ebf13eadf25c6becbd6f1aa.png";